/**
 *  STORAGE/RACK/PLACE JS
 *  Get/add/delete/modify
 */
$(document).ready(function () {
    function trans(translation) {
        var language = document.documentElement.lang;

        return _.get(window.i18n, language + "." + translation);
    }
    if (document.getElementById('warehouse_storage_rack_places')) {

        /* storage */
        $('#warehouse_delete_btn').on('click', function () {

            if (confirm(trans('page.management.warehouse.storage.delete_storage'))) {
                $.ajax({
                    url: '/manage/storage/delete/' + $('#warehouse_select').val(),
                    type: "post",
                    dataType: "json",
                    data: {},
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function (data) {

                        location.reload();
                        alert('Storage Deleted!');
                    },
                    error: function () {
                    }
                });

            } else {
            }
        });
        $('#warehouse_update_tb').on('change', function () {
            if (confirm(trans('page.management.warehouse.storage.update_storage'))) {
                $.ajax({
                    url: '/manage/storage/update/' + $('#warehouse_select').val(),
                    type: "post",
                    dataType: "json",
                    data: {
                        id: $('#warehouse_select').val(),
                        name: $('#warehouse_update_tb').val()

                    },
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function (data) {

                        location.reload();

                    },
                    error: function () {
                    }
                });

            } else {
                alert('Why did you press cancel? You should have confirmed');
            }
        });
        $('#warehouse_create_tb').on('change', function () {

            if (confirm(trans('page.management.warehouse.storage.create_storage'))) {
                $.ajax({
                    url: '/manage/storage/create/' + $("#current_warehouse").val(),
                    type: "post",
                    dataType: "json",
                    data: {
                        id: $('#warehouse_select').val(),
                        name: $('#warehouse_create_tb').val()

                    },
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function (data) {
                        location.reload();

                    },
                    error: function () {
                    }
                });

            } else {

            }
        });
        $('#warehouse_create_btn').on('click', function () {
            $('#warehouse_create_tb').val('');
            $('#warehouse_update_tb').val('');
            if ($('#warehouse_update_tb').is(':visible')) {
                $('#warehouse_update_tb').attr('type', 'hidden');
            }
            if ($('#warehouse_create_tb').is(':visible')) {
                $('#warehouse_create_tb').attr('type', 'hidden');
            } else {
                $('#warehouse_create_tb').attr('type', 'text');
            }
        });
        $('#warehouse_update_btn').on('click', function () {
            $('#warehouse_create_tb').val('');
            $('#warehouse_update_tb').val($('#warehouse_select  option:selected').text());
            if ($('#warehouse_create_tb').is(':visible')) {
                $('#warehouse_create_tb').attr('type', 'hidden');
            }
            if ($('#warehouse_update_tb').is(':visible')) {
                $('#warehouse_update_tb').attr('type', 'hidden');
            } else {
                $('#warehouse_update_tb').attr('type', 'text');
            }
        });
        $('#warehouse_select').on('change', function () {
            $('#warehouse_create_tb').val('');
            $('#warehouse_update_tb').val('');
            $('#warehouse_update_tb').attr('type', 'hidden');
            $('#warehouse_create_tb').attr('type', 'hidden');
            let storageId = $('#warehouse_select').val();
            $('#storage_rack_select').empty();
            $.ajax({
                url: '/manage/storage/rack/view/' + storageId,
                type: "get",
                dataType: "json",
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (data) {
                    $('#storage_rack_select').empty();
                    $('#current_storage_rack').val($('#warehouse_select  option:selected').val());
                    $('#storage_rack_select').append(new Option(trans('page.management.warehouse.storage.choose_rack'), "0"));
                    $.each(data, function (key, value) {
                        $('#storage_rack_select').append(new Option(value["name"], value["id"]));
                    });
                },
                error: function () {

                }
            });
        });
        /* storageRack */
        $('#storage_rack_delete_btn').on('click', function () {

            if (confirm(trans('page.management.warehouse.storage.delete_storage_rack'))) {
                $.ajax({
                    url: '/manage/storage/rack/delete/' + $('#storage_rack_select').val(),
                    type: "post",
                    dataType: "json",
                    data: {},
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function (data) {

                        location.reload();

                    },
                    error: function () {
                    }
                });

            } else {

            }
        });
        $('#storage_rack_update_tb').on('change', function () {
            if (confirm(trans('page.management.warehouse.storage.update_storage_rack'))) {
                $.ajax({
                    url: '/manage/storage/rack/update/' + $('#storage_rack_select').val(),
                    type: "post",
                    dataType: "json",
                    data: {
                        id: $('#storage_rack_select').val(),
                        name: $('#storage_rack_update_tb').val()

                    },
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function (data) {

                        location.reload();

                    },
                    error: function () {
                    }
                });

            } else {

            }
        });
        $('#storage_rack_create_tb').on('change', function () {

            if (confirm(trans('page.management.warehouse.storage.create_storage_rack'))) {
                $.ajax({
                    url: '/manage/storage/rack/create/' + $("#current_storage_rack").val(),
                    type: "post",
                    dataType: "json",
                    data: {
                        id: $('#storage_rack_select').val(),
                        name: $('#storage_rack_create_tb').val()

                    },
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function (data) {
                        location.reload();

                    },
                    error: function () {
                    }
                });

            } else {

            }
        });
        $('#storage_rack_create_btn').on('click', function () {
            $('#storage_rack_create_tb').val('');
            $('#storage_rack_update_tb').val('');
            if ($('#storage_rack_update_tb').is(':visible')) {
                $('#storage_rack_update_tb').attr('type', 'hidden');
            }
            if ($('#storage_rack_create_tb').is(':visible')) {
                $('#storage_rack_create_tb').attr('type', 'hidden');
            } else {
                $('#storage_rack_create_tb').attr('type', 'text');
            }
        });
        $('#storage_rack_update_btn').on('click', function () {
            $('#storage_rack_create_tb').val('');
            $('#storage_rack_update_tb').val($('#storage_rack_select  option:selected').text());
            if ($('#storage_rack_create_tb').is(':visible')) {
                $('#storage_rack_create_tb').attr('type', 'hidden');
            }
            if ($('#storage_rack_update_tb').is(':visible')) {
                $('#storage_rack_update_tb').attr('type', 'hidden');
            } else {
                $('#storage_rack_update_tb').attr('type', 'text');
            }
        });
        $('#storage_rack_select').on('change', function () {
            $('#warehouse_create_tb').val('');
            $('#warehouse_update_tb').val('');
            $('#warehouse_update_tb').attr('type', 'hidden');
            $('#warehouse_create_tb').attr('type', 'hidden');
            $('#storage_rack_create_tb').val('');
            $('#storage_rack_update_tb').val('');
            $('#storage_rack_update_tb').attr('type', 'hidden');
            $('#storage_rack_create_tb').attr('type', 'hidden');

            let storageId = $('#warehouse_select').val();
            let storageRackId = $('#storage_rack_select').val();
            $.ajax({
                url: '/manage/storage/place/view/' + storageRackId,
                type: "get",
                dataType: "json",
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (data) {
                    $('#current_storage_rack').val(storageRackId);
                    $('#storageTable tbody').empty();
                    $('#storageTable tbody').append("<tr id='_'>" +
                        "<td><button id='create_storage_place_btn' type='button' class='form-control glyphicon glyphicon glyphicon-plus'></button>" +
                        "</td>" +
                        "<td><input class='form-control' id='storagePlaceName'  type='text' value=''/></td>" +
                        "<td><input class='form-control' id='storagePlaceWidth'  type='text' value=''/></td>" +
                        "<td><input class='form-control' id='storagePlaceHeight'  type='text' value=''/></td>" +
                        "<td><input class='form-control' id='storagePlaceLength'  type='text' value=''/></td>" +
                        "<td><input class='form-control' id='storagePlaceX'  type='text' value=''/></td>" +
                        "<td><input class='form-control' id='storagePlaceY'  type='text' value=''/></td>" +
                        "<td><input class='form-control' id='storagePlaceZ'  type='text' value=''/></td>" +
                        "</tr>"
                    );
                    $.each(data, function (key, value) {
                        $('#storageTable tbody').append("<tr id='" + value["id"] + "'>" +
                            "<td><button type='button' class='form-control glyphicon glyphicon-pencil storage_table_place_switchWork_btn'></button>" +
                            "<button type='button' class='form-control glyphicon glyphicon glyphicon-trash storage_table_place_delete_btn'></button></td>" +
                            "<td><input class='form-control storage_table_place workability_" + value["id"] + "' readonly type='text' name='place[" + value["id"] + "][name]' value='" + value["name"] + "'/></td>" +
                            "<td><input class='form-control storage_table_place workability_" + value["id"] + "' readonly type='text' name='place[" + value["id"] + "][width]' value='" + value["width"] + "'/></td>" +
                            "<td><input class='form-control storage_table_place workability_" + value["id"] + "' readonly type='text' name='place[" + value["id"] + "][height]' value='" + value["height"] + "'/></td>" +
                            "<td><input class='form-control storage_table_place workability_" + value["id"] + "' readonly type='text' name='place[" + value["id"] + "][length]' value='" + value["length"] + "'/></td>" +
                            "<td><input class='form-control storage_table_place workability_" + value["id"] + "' readonly type='text' name='place[" + value["id"] + "][x]' value='" + value["x"] + "'/></td>" +
                            "<td><input class='form-control storage_table_place workability_" + value["id"] + "' readonly type='text' name='place[" + value["id"] + "][y]' value='" + value["y"] + "'/></td>" +
                            "<td><input class='form-control storage_table_place workability_" + value["id"] + "' readonly type='text' name='place[" + value["id"] + "][z]' value='" + value["z"] + "'/></td>" +
                            "</tr>"
                        );
                    });
                },
                error: function () {

                }
            });
        });
        /* storagePlace */
        $(document).on('click', '.storage_table_place_switchWork_btn', function (e) {
            let trid = $(this).closest('tr').attr('id');
            if ($(".workability_" + trid).is('[readonly]')) {
                $(".workability_" + trid).attr('readonly', false);
                $(".workability_" + trid).removeClass('storage_table_place');

            } else {
                $(".workability_" + trid).attr('readonly', true);
                $(".workability_" + trid).addClass('storage_table_place');
            }


        });
        $(document).on('click', '.storage_table_place_delete_btn', function (e) {
            $(this).closest('tr').remove();


        });
        $(document).on('click', '#create_storage_place_btn', function (e) {
            if (confirm('Create Storage Place?')) {
                $.ajax({
                    url: '/manage/storage/place/create/' + $('#storage_rack_select').val(),
                    type: "post",
                    dataType: "json",
                    data: {
                        name: $('#storagePlaceName').val(),
                        width: $('#storagePlaceWidth').val(),
                        height: $('#storagePlaceHeight').val(),
                        length: $('#storagePlaceLength').val(),
                        varX: $('#storagePlaceX').val(),
                        varY: $('#storagePlaceY').val(),
                        varZ: $('#storagePlaceZ').val()

                    },
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function (data) {
                        $('#warehouse_create_tb').val('');
                        $('#warehouse_update_tb').val('');
                        $('#warehouse_update_tb').attr('type', 'hidden');
                        $('#warehouse_create_tb').attr('type', 'hidden');
                        $('#storage_rack_create_tb').val('');
                        $('#storage_rack_update_tb').val('');
                        $('#storage_rack_update_tb').attr('type', 'hidden');
                        $('#storage_rack_create_tb').attr('type', 'hidden');

                        let storageId = $('#warehouse_select').val();
                        let storageRackId = $('#storage_rack_select').val();
                        $.ajax({
                            url: '/manage/storage/place/view/' + storageRackId,
                            type: "get",
                            dataType: "json",
                            headers: {
                                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                            },
                            success: function (data) {
                                $('#storageTable tbody').empty();
                                $('#storageTable tbody').append("<tr>" +
                                    "<td><button id='create_storage_place_btn' class='form-control glyphicon glyphicon glyphicon-plus'></button>" +
                                    "</td>" +
                                    "<td><input class='form-control' id='storagePlaceName'  type='text' value=''/></td>" +
                                    "<td><input class='form-control' id='storagePlaceWidth'  type='text' value=''/></td>" +
                                    "<td><input class='form-control' id='storagePlaceHeight'  type='text' value=''/></td>" +
                                    "<td><input class='form-control' id='storagePlaceLength'  type='text' value=''/></td>" +
                                    "<td><input class='form-control' id='storagePlaceX'  type='text' value=''/></td>" +
                                    "<td><input class='form-control' id='storagePlaceY'  type='text' value=''/></td>" +
                                    "<td><input class='form-control' id='storagePlaceZ'  type='text' value=''/></td>" +
                                    "</tr>"
                                );
                                $.each(data, function (key, value) {
                                    $('#storageTable tbody').append("<tr>" +
                                        "<td><button class='form-control glyphicon glyphicon-pencil'></button>" +
                                        "<button class='form-control glyphicon glyphicon glyphicon-trash'></button></td>" +
                                        "<td><input class='form-control storage_table_place' readonly type='text' value='" + value["name"] + "'/></td>" +
                                        "<td><input class='form-control storage_table_place' readonly type='text' value='" + value["width"] + "'/></td>" +
                                        "<td><input class='form-control storage_table_place' readonly type='text' value='" + value["height"] + "'/></td>" +
                                        "<td><input class='form-control storage_table_place' readonly type='text' value='" + value["length"] + "'/></td>" +
                                        "<td><input class='form-control storage_table_place' readonly type='text' value='" + value["x"] + "'/></td>" +
                                        "<td><input class='form-control storage_table_place' readonly type='text' value='" + value["y"] + "'/></td>" +
                                        "<td><input class='form-control storage_table_place' readonly type='text' value='" + value["z"] + "'/></td>" +
                                        "</tr>"
                                    );
                                });
                            },
                            error: function () {

                            }
                        });

                    },
                    error: function () {
                    }
                });

            } else {

            }

        });

    }
});